var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.693,
    height: 12.171,
    viewBox: "0 0 13.693 12.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users",
    d: "M105.128,201.16v-.627a3.4,3.4,0,0,0,1.521-2.827c0-1.891,0-3.423-2.282-3.423s-2.282,1.533-2.282,3.423a3.4,3.4,0,0,0,1.521,2.827v.627c-2.58.211-4.564,1.479-4.564,3.012h10.65C109.693,202.638,107.709,201.37,105.128,201.16Zm-5.239.294a7.227,7.227,0,0,1,2.375-.956,4.292,4.292,0,0,1-.481-.7,4.356,4.356,0,0,1-.553-2.091,6.754,6.754,0,0,1,.364-2.779,2.477,2.477,0,0,1,1.893-1.42c-.2-.909-.736-1.507-2.161-1.507-2.282,0-2.282,1.533-2.282,3.423a3.4,3.4,0,0,0,1.521,2.827v.627c-2.58.211-4.564,1.479-4.564,3.012h3.316A4.871,4.871,0,0,1,99.889,201.453Z",
    transform: "translate(-96 -192)",
    fill: "CurrentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.92f88894.svg";
export { ForwardRef as ReactComponent };